/**
 * @flow
 * @relayHash 0e81762984c1dd1c44dacec63520f6ce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteBillingAddressMutationVariables = {|
  id: string
|};
export type DeleteBillingAddressMutationResponse = {|
  +deleteBillingAddress: {|
    +id: string
  |}
|};
export type DeleteBillingAddressMutation = {|
  variables: DeleteBillingAddressMutationVariables,
  response: DeleteBillingAddressMutationResponse,
|};
*/


/*
mutation DeleteBillingAddressMutation(
  $id: String!
) {
  deleteBillingAddress(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteBillingAddress",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "BillingAddressModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteBillingAddressMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteBillingAddressMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteBillingAddressMutation",
    "id": null,
    "text": "mutation DeleteBillingAddressMutation(\n  $id: String!\n) {\n  deleteBillingAddress(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '09932ceefaa521b4691cb1f3fe1749b1';
module.exports = node;
